import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import {
  DESTRUCTIVE_COLOR,
  SECONDARY_COLOR,
} from "@hl/base-components/lib/theme/button";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { Text, Modal, Button, Group } from "@mantine/core";

import { useRemoveCreatorMarketingAccessMutation } from "~/features/account/settings.graphql.generated";

type UnlinkEmailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  creatorId: string;
  walletAddress: string;
  ensName?: string;
};

export const UnlinkEmailModal = ({
  isOpen,
  onClose,
  creatorId,
  walletAddress,
  ensName,
}: UnlinkEmailModalProps) => {
  const [removeCreatorAccessMutation, { loading, error, reset }] =
    useRemoveCreatorMarketingAccessMutation({
      variables: {
        creatorId,
      },
      onCompleted: onClose,
    });

  const onCloseHandler = () => {
    onClose();
    reset();
  };

  return (
    <Modal
      size="lg"
      opened={isOpen}
      onClose={onCloseHandler}
      title={
        <Text size="lg" weight={500}>
          Unlink email
        </Text>
      }
    >
      <Text size="sm">
        If you unlink your email, you will no longer have access to any pages
        and mints that require an email from{" "}
        <Text span size="sm" weight={500}>
          {ensName || walletAddress}
        </Text>
        .
      </Text>
      <ModalSection>
        <Group noWrap>
          <Button
            fullWidth
            color={SECONDARY_COLOR}
            size="xl"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            color={DESTRUCTIVE_COLOR}
            size="xl"
            loading={loading}
            onClick={() => removeCreatorAccessMutation()}
          >
            Unlink
          </Button>
        </Group>
        {error && (
          <Text mt="md" size="sm" color={STATUS_COLOR.ERROR}>
            Error unlinking creator access.
          </Text>
        )}
      </ModalSection>
    </Modal>
  );
};
